"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertStory = exports.convertStoryForNewPlayer = void 0;
const stories_1 = require("../types/stories");
const web_story_web_player_1 = require("@snapchat/web-story-web-player");
const conversions_1 = require("../conversions");
/**
 *
 */
function convertStoryForNewPlayer(playerStory) {
    if (playerStory)
        return (0, conversions_1.toWebPlayerStoryConversion)(playerStory);
    else
        return { snaps: [], type: web_story_web_player_1.WWWStoryType.SPOTLIGHT };
}
exports.convertStoryForNewPlayer = convertStoryForNewPlayer;
/**
 *
 */
function convertStory(playerStory) {
    if (playerStory)
        return (0, conversions_1.toStoryConversion)(playerStory);
    else
        return { snapList: [], storyType: stories_1.StoryType.SPOTLIGHT };
}
exports.convertStory = convertStory;
//# sourceMappingURL=spotlight.js.map